/* ═══════════════════════════════════════════════════════════
   ASTROITE — i18n configuration (single source of truth)

   Add a new language in ONE place: append its code to LANGS and
   give it a LANG_LABELS / LANG_NAMES entry, then add its column
   to the tables in strings.js / sites.js. Everything else
   (selector, persistence, fallback) scales automatically.
   ═══════════════════════════════════════════════════════════ */

// Order here defines the order shown in the language selector.
export const LANGS = ['hi', 'mr', 'en'];

// First-run default for the post-login experience (primary audience:
// elderly / children, Hindi-first). The login screen is always English,
// independent of this value.
export const DEFAULT_LANG = 'hi';

// Compact label shown inside the selector chip.
export const LANG_LABELS = { hi: 'हिं', mr: 'मर', en: 'EN' };

// Full endonym shown in the selector dropdown rows.
export const LANG_NAMES = { hi: 'हिन्दी', mr: 'मराठी', en: 'English' };

const STORAGE_KEY = 'astroite_lang';

/* localStorage is unavailable in some environments (SSR, private mode,
   storage disabled). Access it defensively so dev, prod, and locked-down
   browsers all behave identically — never throw. */
function safeStorage() {
  try {
    if (typeof window === 'undefined' || !window.localStorage) return null;
    return window.localStorage;
  } catch {
    return null;
  }
}

export function isLang(value) {
  return LANGS.indexOf(value) !== -1;
}

/** Read the persisted language, validated. Falls back to DEFAULT_LANG. */
export function getStoredLang() {
  try {
    const ls = safeStorage();
    const value = ls && ls.getItem(STORAGE_KEY);
    return isLang(value) ? value : DEFAULT_LANG;
  } catch {
    return DEFAULT_LANG;
  }
}

/** Persist the language. No-op if storage is unavailable or value invalid. */
export function setStoredLang(lang) {
  if (!isLang(lang)) return;
  try {
    const ls = safeStorage();
    if (ls) ls.setItem(STORAGE_KEY, lang);
  } catch {
    /* ignore — persistence is best-effort */
  }
}
